export default __webpack_public_path__ + "static/media/WM0400.34I-43894_-26188_0.677a67d3.jpg";